import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const transcribation = {
  updateTranscribationText: lazyModuleMethod(
    () => import('./updateTranscribationText'),
    'default'
  ),
}
